/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnUserGender } from './en-user-gender';
 /**
 *
 *
 * @export
 * @interface CreateMemberDto
 */
export interface CreateMemberDto {

    /**
     * @type {string}
     * @memberof CreateMemberDto
     */
    firstName: string;

    /**
     * @type {string}
     * @memberof CreateMemberDto
     */
    lastName: string;

    /**
     * @type {string}
     * @memberof CreateMemberDto
     */
    fiscalCode: string;

    /**
     * @type {string}
     * @memberof CreateMemberDto
     */
    email?: string | null;

    /**
     * @type {string}
     * @memberof CreateMemberDto
     */
    dateOfBirth?: string | null;

    /**
     * @type {number}
     * @memberof CreateMemberDto
     */
    height?: number | null;

    /**
     * @type {number}
     * @memberof CreateMemberDto
     */
    weight?: number | null;

    /**
     * @type {EnUserGender}
     * @memberof CreateMemberDto
     */
    gender?: EnUserGender | null;

    /**
     * @type {string}
     * @memberof CreateMemberDto
     */
    note?: string | null;

    /**
     * @type {number}
     * @memberof CreateMemberDto
     */
    education: number;
}
